import {useCallback, useEffect, useRef, useState} from 'react'
import {ReportType} from '../../../types/report-type'
import {ReportDatasets, reportDatasets, ReportFilters, requestReport} from './reportData'

export function useReportData(type: ReportType) {
  const [filters, setFilters] = useState<ReportFilters | null>(null)
  const [limit, setLimit] = useState(100)
  const [datasets, setDatasets] = useState<ReportDatasets | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const requestId = useRef(0)
  const reload = useCallback(async () => {
    if (!filters) return
    const current = ++requestId.current
    setLoading(true)
    setError(false)
    setDatasets(null)
    try {
      const response = await requestReport(type, filters, false, limit)
      if (current !== requestId.current) return
      setDatasets(reportDatasets(type, response))
    } catch {
      if (current === requestId.current) setError(true)
    } finally {
      if (current === requestId.current) setLoading(false)
    }
  }, [type, filters, limit])
  useEffect(() => {
    reload()
    return () => {
      requestId.current += 1
    }
  }, [reload])

  const applyFilters = (next: ReportFilters) => {
    // Loading starts in the same render that closes the filter dialog.
    requestId.current += 1
    setLoading(true)
    setError(false)
    setDatasets(null)
    setFilters({...next})
  }
  const changeLimit = (next: number) => {
    if (next === limit) return
    if (filters) {
      requestId.current += 1
      setLoading(true)
      setError(false)
      setDatasets(null)
    }
    setLimit(next)
  }
  return {filters, limit, datasets, loading, error, reload, applyFilters, changeLimit}
}
